import { render } from "./PronosticoForm.vue?vue&type=template&id=9bcd91da&scoped=true"
import script from "./PronosticoForm.vue?vue&type=script&lang=js"
export * from "./PronosticoForm.vue?vue&type=script&lang=js"

import "./PronosticoForm.vue?vue&type=style&index=0&id=9bcd91da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcd91da"]])

export default __exports__